import {
    ApplicationRef,
    ComponentFactoryResolver, ComponentRef,
    Injectable, Injector, Type
} from '@angular/core';
import { SlideInPanelComponent } from '../shared/slide-in-panel/slide-in-panel.component';

@Injectable({
    providedIn: 'root'
})
export class SlideInPanelService {

    constructor(private app: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private injector: Injector) {
    }

    open(cmp: Type<any>): SlideInPanelComponent {
        const panelFactory = this.componentFactoryResolver.resolveComponentFactory(SlideInPanelComponent);

        const newNode = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(newNode);

        const panelComponent = panelFactory.create(this.injector, [], newNode);
        panelComponent.instance.onClosed.subscribe(() => this.onPanelClosed(panelComponent))
        this.app.attachView(panelComponent.hostView);

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(cmp);
        const component = componentFactory.create(this.injector);
        panelComponent.instance.contentRef.insert(component.hostView);

        return panelComponent.instance;
    }

    private onPanelClosed(cmp: ComponentRef<any>) {
        cmp.destroy();
    }
}
